import React from 'react';
import { ChevronDown } from 'lucide-react';

const FAQ = () => {
  const faqs = [
    {
      question: "Do all bets count towards the leaderboard?",
      answer: "Yes, you are free to use any wager strategy, including 99% Dice or any other wager-focused strategy. However, please note that abusive or exploitative behavior, such as artificial wager inflation, may result in disqualification. Always play responsibly and check the terms for any restrictions."
    },
    {
      question: "What rewards can I expect additionally?",
      answer: "For additional rewards like exclusive code drops, giveaways, or VIP transfer rewards, please join our Discord and open a ticket. You can find the Discord link in the socials tab."
    },
    {
      question: "How often is the wager leaderboard updated?",
      answer: "The leaderboard is updated every 24 hours, ensuring the latest wager data is displayed daily."
    },
    {
      question: "How do I qualify for the wager leaderboard?",
      answer: "To qualify, simply place bets on goated using our affiliate link. Your total wagered amount will automatically count towards the leaderboard."
    }
  ];

  return (
    <section id="faq" className="py-16 px-4 scroll-mt-20">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 bg-gradient-to-r from-[#D7FF00] to-white bg-clip-text text-transparent">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-white/5 border border-white/10 rounded-xl overflow-hidden"
            >
              <summary className="flex items-center justify-between p-6 cursor-pointer">
                <h3 className="text-lg font-semibold pr-8">{faq.question}</h3>
                <ChevronDown className="w-5 h-5 transition-transform group-open:rotate-180" />
              </summary>
              <div className="px-6 pb-6 text-gray-400">
                <p>{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;